import { useCallback } from 'react';
import { useIsInFragmentScreens, useOpenDeeplink } from '../../../../hooks';
import { appendParams, finalizeUrl, getDefaultDeeplink } from '../../utils';
import { useRootStackNavigation } from '../../../../hooks/useRootNavigation';

const GOODS_LIST_DEEPLINK_PREFIX = 'ably://goods_list';

const parseGoodsListDeeplink = (deeplink: string) => {
  if (!deeplink.startsWith(GOODS_LIST_DEEPLINK_PREFIX)) return null;
  const queryPart = deeplink.split('?')[1];
  if (!queryPart) return null;

  const params = new URLSearchParams(queryPart);
  const goodsSnoRaw = params.get('goods_sno');
  const type = params.get('type');
  if (!goodsSnoRaw || !type) return null;

  const goodsSno = Number(goodsSnoRaw);
  if (Number.isNaN(goodsSno)) return null;

  // Navigator.convertParams가 snake_case로 읽으므로 동일 형태로 보존
  return {
    type,
    goods_sno: goodsSno,
    landing_from: params.get('landing_from') ?? undefined,
    position: params.get('position') ?? undefined,
  };
};

export const useMoveToGoodsList = () => {
  const { openDeeplink } = useOpenDeeplink();
  const isInFragments = useIsInFragmentScreens();
  const navigation = useRootStackNavigation();

  return useCallback(
    (deeplink: string) => {
      const extras = parseGoodsListDeeplink(deeplink);
      if (extras === null) return false;

      const url = getDefaultDeeplink();
      appendParams(url, 'screen', 'GoodsList');
      appendParams(url, 'extras', JSON.stringify(extras));

      if (isInFragments) {
        openDeeplink(finalizeUrl(url));
      } else {
        navigation.push('GoodsList', {
          type: extras.type,
          goodsSno: extras.goods_sno,
          landingFrom: extras.landing_from,
          position: extras.position,
        });
      }
      return true;
    },
    [openDeeplink, navigation, isInFragments],
  );
};
